import { styled } from "@mui/material/styles";
import clsx from "clsx";

const Root = styled("div")(({ theme }) => ({
	"& > .logo-icon": {
		transition: theme.transitions.create(["width", "height"], {
			duration: theme.transitions.duration.shortest,
			easing: theme.transitions.easing.easeInOut,
		}),
	},
	"& > .badge": {
		transition: theme.transitions.create("opacity", {
			duration: theme.transitions.duration.shortest,
			easing: theme.transitions.easing.easeInOut,
		}),
	},
}));

type LogoProps = {
	className?: string;
};

function Logo(props: Readonly<LogoProps>) {
	const { className = "" } = props;

	return (
		<Root className={clsx("flex flex-shrink-0 items-center", className)}>
			<div className={clsx("flex items-center")}>
				<img
					className={clsx("logo-icon h-7 w-auto max-w-[116px] sm:h-8 sm:max-w-none md:h-10")}
					src="/assets/space/logo_space.png"
					alt="Space Software"
				/>
			</div>
		</Root>
	);
}

export default Logo;
